import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import * as homeActions from '../home/redux/actions';
import * as serviceActions from '../pb-service-list/redux/actions';

import { KuposInput, KuposSelectBox, KuposSteps, PaymentOptions } from '../common';
import React, { useEffect, useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';

import ApiUrls from '../../services/apiUrls';
import CommonService from '../../services/commonService';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../themes/functions/getIcons/getIcons';

const operator = CommonService.getLocal('op');
const loginData = CommonService.getLocal('loginData');



const stepsMenu = [
	{ label: 'GOING' },
	{ label: 'PAYMENT', active: true },
	{ label: 'CONFIRMATION' },
];
const onStepClick = () => { };
const CuponeraPayment = ({ home, common, cuponera, t, actions, history }) => {

	const operator = CommonService.getLocal('op');
	const stylesTagStyle = operator
		? `
.cuponera-sidebar-total-sum-box {
	background-color: ${operator.color_codes.secondary_color};
	color: white;
}
.cuponera-sidebar-hr {
	background-color: ${operator.color_codes.primary_color};
}
.cuponera-ticket-box-relative-selected .cuponera-ticket-box-total-sum-box {
	background-color: ${operator.color_codes.secondary_color};
	color: white;
}
`
		: '';

	const { selectedCuponera } = cuponera;
	const { setSelectCuponera } = actions;

	const [countries, setCountries] = useState([]);
	const [totalAmount, setTotalAmount] = useState(0);
	const [isOneClickEnabled, setIsOneClickEnabled] = useState(false);
	const [selectedSeats, setSelectedSeats] = useState({});
	const [idCardTypes, setIdCardTypes] = useState([
		{ value: 7, label: 'RUT (CHL)' },
		{ value: 3, label: 'DNI/Pasaporte' },

	]);
	let [inputs, setInputs] = useState({
		country: countries[0],
		idCardType: idCardTypes[0],
	});

	const [paymentGatewayList, setPaymentGatewayList] = useState([]);
	const [selectedPaymentGateway, setSelectedPaymentGateway] = useState(null);
	const [wallet, setWallet] = useState(false);
	const [tncChecked, setTncChecked] = useState(false);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (home && home.metaData) setIsOneClickEnabled(home.metaData.is_oneclick_card_enable);
	}, [home]);

	useEffect(() => {
		let countriesLocal = [];
		let idsLocal = [];
		if (home.metaData) {
			for (let c in home.metaData.nationality_list) {
				countriesLocal.push({
					value: home.metaData.nationality_list[c],
					label: c.substring(0, 3).toUpperCase(),
				});
			}
			setCountries(countriesLocal);

			for (let c in home.metaData.id_card_types) {
				if (idCardTypes.length <= 1) {
					idsLocal.push({
						value: home.metaData.id_card_types[c],
						label: c,
					});
				}

				setInputs({
					...inputs,
					idCardType: idsLocal.length ? idsLocal[0] : inputs.idCardType,
					country: countriesLocal[0],
				});
				setIdCardTypes(idsLocal);
			}

			let pgList = CommonService.copyObject(home.metaData.payment_gate_way_list_v1);
			setPaymentGatewayList(pgList);
		}

		if (loginData) {
			setInputs({
				...inputs,
				name: loginData.name,
				lastName: loginData.last_name,
				mobile: loginData.phone,
				idCardNumber: loginData.identity_val,
				email: loginData.email,
				confirmEmail: loginData.email,
				idCardType:
					loginData.identity_type === 7
						? { value: 7, label: 'RUT (CHL)' }
						: { value: 3, label: 'DNI/Pasaporte' },
				country: countriesLocal[0],
				idCardTypeValue: loginData.identity_type,
			});
		} else {

			// setInputs({
			// 	...inputs,
			// 	idCardType: { value: 7, label: 'RUT (CHL)' }, // Default value and label
			// });
			// history.push('/');
		}



		if (selectedCuponera) {
			console.log("selected selectedCuponera", selectedCuponera);
			setSelectedSeats(selectedCuponera);
			setTotalAmount(selectedCuponera.total_net_amount);
		} else {
			console.log("nonselected selectedCuponera", selectedCuponera);
			let selectedCuponeraTemp = JSON.parse(sessionStorage.getItem('selectedCuponera'));
			if (selectedCuponeraTemp) {
				setSelectedSeats(selectedCuponeraTemp);
				setSelectCuponera(selectedCuponeraTemp);
				setTotalAmount(selectedCuponeraTemp.total_net_amount);
			} else {
				history.push('/');
			}
		}

		if (!(home.pbSourceCity && home.pbDestinationCity)) {
			let source = JSON.parse(sessionStorage.getItem('cuponeraSourceCity'));
			let destination = JSON.parse(sessionStorage.getItem('cuponeraDestinationCity'));
			if (source && destination) {
				actions.pbSetSourceCity(source);
				actions.pbSetDestinationCity(destination);
			} else {
				history.push('/');
			}
		}
	}, [home]);

	const walletMoney = netFare => {
		// instant discount
		try {
			if (common &&
				common.loginData &&
				common.loginData.balances &&
				wallet
			) {
				let money = common.loginData.balances.clp.money;
				return +money;
			}
			return 0;
		} catch (e) {
			console.log(e);
		}
	};
	const calculateNetFare = () => {
		try {
			let fare = totalAmount
			if (wallet) {
				fare = fare - +walletMoney(fare) < 0 ? 0 : fare - +walletMoney(fare);
			}
			return fare;
		} catch (e) {
			console.log(e);
		}
	};


	console.log('calculateNetFare', calculateNetFare())

	const onPay = () => {
		let inputsLocalState = CommonService.copyObject(inputs);

		let errors = 0;
		if (!inputs.name) {
			inputsLocalState['nameError'] = 'VALIDATIONS.VALID_NAME';

			errors++;
		}
		if (!inputs.lastName) {
			inputsLocalState['lastNameError'] = 'VALIDATIONS.VALID_SURNAME';
			errors++;
		}
		if (!inputs.idCardNumber) {
			inputsLocalState['idCardNumberError'] = 'VALIDATIONS.VALID_RUT';
			errors++;
		}

		if (!inputs.email) {
			inputsLocalState['emailError'] = 'VALIDATIONS.VALID_EMAIL';
			errors++;
		}

		if (!inputs.confirmEmail) {
			inputsLocalState['confirmEmailError'] = 'VALIDATIONS.VALID_CONFIRM_EMAIL';
			errors++;
		}

		if (inputs.email && !CommonService.isEMailValid(inputs.email)) {
			inputsLocalState['emailError'] = 'VALIDATIONS.VALID_EMAIL_VALIDATION';
			errors++;
		}

		if (inputs.email && inputs.confirmEmail && inputs.email != inputs.confirmEmail) {
			inputsLocalState['confirmEmailError'] = 'VALIDATIONS.VALID_EMAIL_MATCH';
		}

		if (!inputs.mobile) {
			inputsLocalState['mobileError'] = 'VALIDATIONS.VALID_MOBILE';
			errors++;
		}

		setInputs(inputsLocalState);

		if (errors > 0) {
			return;
		}

		// OPERATOR PAY = 52
		// CREDIT  = 53
		// DEBIT = 54

		const paymentgateWaykey = {
			'35': '48', // web  key
			'39:3': '52:3', // operator key
			'41:2': '54',
			'40:2': '53',
		};

		let paymentTypeNumber = paymentgateWaykey[selectedPaymentGateway];

		let data = {
			return_url: window.location.origin,
			zone_id: selectedSeats.zone_id,
			origin_id: home.pbSourceCity.value,
			destination_id: home.pbDestinationCity.value,
			api_travel_id: operator.travel_ids,
			pay_gay_type: paymentTypeNumber,
			id_number: inputs.idCardNumber,
			id_type: inputs.idCardType ? inputs.idCardType.value : 7,
			title: 'Mr',
			passenger_name: inputs.name + "_" + inputs.lastName,
			phone_number: inputs.mobile,
			email: inputs.email,
			coupon_amount: selectedSeats.total_coupon_amount - selectedSeats.total_discount_amount,
			total_net_amount: selectedSeats.total_coupon_amount - selectedSeats.total_discount_amount,
		};

		setLoading(true);

		actions.apiCall({
			type: 'home',

			url: ApiUrls.bookCuponera(),
			callback: res => {
				console.log('res', res);
				//   if (res && res.data && res.data.success && res.data.result) {
				//     if (res.data.result.html_str) {
				//       document.write(res.data.result.html_str);
				//     } else if (res.data.result.pnr_number) {
				//       history.push(`/cuponera/payment/success/${res.data.result.pnr_number}`);
				//     } else {
				//       history.push(`/cuponera/payment/failure`);
				//     }
				//   } else {
				//     history.push('/cuponera/payment/failure');
				//   }
				// },
				if (res && res.data && res.data.success && res.data.result.html_str) {
					if (res.data.result.html_str) {
						document.write(res.data.result.html_str);
					} else {
						history.push('/cuponera/payment/success');
					}
				} else if (
					res &&
					res.data &&
					res.data.result &&
					res.data.result.result &&
					res.data.result.result.pnr_number
				) {
					history.push('/cuponera/payment/success');
				} else {
					history.push('/cuponera/payment/failure');
				}
			},
			method: 'POST',
			data,
		});
	};
	const inputBlur = (text, type) => {
		if (!text) {
			if (type === 'name') {
				setInputs({ ...inputs, nameError: 'VALIDATIONS.VALID_NAME' });
			}
			if (type === 'lastName') {
				setInputs({ ...inputs, lastNameError: 'VALIDATIONS.VALID_SURNAME' });
			}
			if (type === 'idCardNumber') {
				setInputs({ ...inputs, idCardNumberError: 'VALIDATIONS.VALID_RUT' });
			}
			if (type === 'email') {
				setInputs({ ...inputs, emailError: 'VALIDATIONS.VALID_EMAIL' });
			}
			if (type === 'confirmEmail') {
				setInputs({
					...inputs,
					confirmEmailError: 'VALIDATIONS.VALID_CONFIRM_EMAIL',
				});
			}
			if (type === 'mobile') {
				setInputs({ ...inputs, mobileError: 'VALIDATIONS.VALID_MOBILE' });
			}
		} else {
			if (type === 'email' && !CommonService.isEMailValid(text)) {
				setInputs({ ...inputs, emailError: 'VALIDATIONS.VALID_EMAIL' });
			}
			if (type === 'confirmEmail' && !CommonService.isEMailValid(text)) {
				setInputs({
					...inputs,
					confirmEmailError: 'VALIDATIONS.VALID_CONFIRM_EMAIL',
				});
			}

			if (type === 'confirmEmail' && inputs.email && inputs.email != text) {
				setInputs({
					...inputs,
					confirmEmailError: 'VALIDATIONS.VALID_EMAIL_MATCH',
				});
			}

			if (type === 'idCardNumber') {
				getPassengerDetailsInfo();
			}
		}
	};
	const getPassengerDetailsInfo = () => {
		actions
			.getPassengerInfo({
				url: ApiUrls.getPassengerInfo({
					cardType: inputs.idCardType.value,
					idCardNumber: inputs.idCardNumber && inputs.idCardNumber.replace(/[\.\-]/g, ''),
				}),
			})
			.then(res => {
				if (res && res.data && res.data.success && res.data.body) {
					let country = countries.find(country => country.id === res.data.body.nationality_id);
					setInputs(prevData => ({
						...prevData,
						name: res.data.body.name.split('_')[0],
						nameError: '',
						lastName: res.data.body.name.split('_')[1] || '',
						lastNameError: '',
						email: res.data.body.email,
						emailError: '',
						confirmEmail: res.data.body.email,
						confirmEmailError: '',
						mobile: res.data.body.phone,
						mobileError: '',
						country: country || countries[0],
					}));
				}
			});
	};

	const onChange = (val, type) => {
		let error = `${type}Error`;

		if (type === 'idCardNumber' && idCardTypes.value === 7) {
			setInputs({
				...inputs,
				[type]: CommonService.formatRut(val),
				[error]: null,
			});
		} else {
			setInputs({ ...inputs, [type]: val, [error]: null });
		}
	};

	const onPaymentTypeSelect = paymentItem => {
		if (paymentItem) {
			setSelectedPaymentGateway(
				selectedPaymentGateway === paymentItem.code ? null : paymentItem.code,
			);
		} else {
			setSelectedPaymentGateway(34);
		}
	};

	return (
		<div className="content-container">
			<style>{stylesTagStyle}</style>
			<KuposSteps menuButtons={stepsMenu} t={t} onStepClick={onStepClick} />
			<div
				className="passenger_inputs_summary_wrapper"
				style={styles.passenger_inputs_summary_wrapper}
			>
				<div style={styles.passenger_inputs_wrapper}>
					<CuponeraBookingInputs
						idCardTypes={idCardTypes}
						countries={countries}
						passengerDetails={inputs}
						onChange={onChange}
						onInputBlur={inputBlur}
						seatsTitle="Información del pasajero"
						t={t}
					/>
					<PaymentOptions
						t={t}
						walletChecked={wallet}
						onPaymentSelect={onPaymentTypeSelect}
						selected={selectedPaymentGateway}
						checkWallet={() => {
							setWallet(!wallet);
						}}
						onPay={onPay}
						basicFare={totalAmount}
						totalAmount={calculateNetFare()}
						showPromocode={false}
						showKuposPay={false}
						showMachpay={false}
						showPaypal={false}
						showBancoEstado={false}
						showBancoEstadoNew={true}
						bookTicketPending={loading}
						onTncChange={() => setTncChecked(!tncChecked)}
						tncChecked={tncChecked}
						isOneClickEnabled={isOneClickEnabled}
						paymentGatewayList={paymentGatewayList}
						isAdmin={loginData && loginData.role && loginData.is_agency_user ? true : false}
						enableOneClickPG={false}
						operator={operator}
						showVirtualWallet={false}
					/>
				</div>
				<SummarySection t={t} cuponera={cuponera} />
			</div>
		</div>
	);
};

const CuponeraBookingInputs = ({
	idCardTypes,
	countries,
	passengerDetails,
	onChange,
	onInputBlur,
	seatsTitle,
}) => {
	const { t } = useTranslation('common');

	return (
		<div className="pb-payment-details-booking-input kupos-card" style={{ padding: '35px' }}>
			<div style={styles.info_title} className="bold-text font13">
				{seatsTitle}
			</div>

			<div style={styles.passenger_input_wrapper_labels} className="bold-text font9">
				<span className="nationality-input">{t('PASSENGER_DETAILS.NATIONALITY')}</span>
				<span className="doc-input">{t('PASSENGER_DETAILS.DOCUMENT')}</span>
				<span className="rut-input">{t('PASSENGER_DETAILS.DOC_NUM_DEGREE')}</span>
				<span className="name-input">{t('PASSENGER_DETAILS.NAME')}</span>
				<span className="last_name-input">{t('PASSENGER_DETAILS.SURNAME')}</span>
			</div>
			<div style={styles.passenger_input_wrapper} className="font9">
				<span className="nationality-input" style={styles.country_dd}>
					<KuposSelectBox
						options={countries}
						selectedOption={
							passengerDetails && passengerDetails.country
								? passengerDetails.country
								: { value: 1, label: 'CHL' }
						}
						onChange={val => onChange(val, 'country')}
						height={40}
						showAll={true}
						disabled={loginData ? true : false}
						t={t}
						marginTop={0.1}
					/>
				</span>
				<span className="doc-input">
					{passengerDetails.idCardType && (
						<KuposSelectBox
							options={idCardTypes}
							selectedOption={passengerDetails.idCardType}
							onChange={val => onChange(val, 'idCardType')}
							height={40}
							showAll={true}
							disabled={loginData ? true : false}
							t={t}
							marginTop={0.1}
						/>
					)}
				</span>
				<span className="rut-input">
					<KuposInput
						className="kupos-border"
						type="text"
						value={
							passengerDetails ? CommonService.formatRut(passengerDetails.idCardNumber || '') : ''
						}
						onChange={text => onChange(text, 'idCardNumber')}
						onBlur={text => onInputBlur(text, 'idCardNumber')}
						error={passengerDetails && passengerDetails.idCardNumberError ? true : false}
						errorMessage={
							passengerDetails && passengerDetails.idCardNumberError
								? t(passengerDetails.idCardNumberError)
								: ''
						}
						t={t}
						disabled={loginData ? true : false}
					/>
				</span>
				<span className="name-input">
					<KuposInput
						className="kupos-border"
						type="text"
						value={passengerDetails ? passengerDetails.name : ''}
						onChange={text => onChange(text, 'name')}
						onBlur={text => onInputBlur(text, 'name')}
						error={passengerDetails && passengerDetails.nameError ? true : false}
						errorMessage={
							passengerDetails && passengerDetails.nameError ? t(passengerDetails.nameError) : ''
						}
						t={t}
						disabled={loginData ? true : false}
					/>
				</span>
				<span className="name-input">
					<KuposInput
						className="kupos-border"
						type="text"
						value={passengerDetails ? passengerDetails.lastName : ''}
						onChange={text => onChange(text, 'lastName')}
						onBlur={text => onInputBlur(text, 'lastName')}
						error={passengerDetails && passengerDetails.lastNameError ? true : false}
						errorMessage={
							passengerDetails && passengerDetails.lastNameError
								? t(passengerDetails.lastNameError)
								: ''
						}
						t={t}
						disabled={loginData ? true : false}
					/>
				</span>
			</div>

			<div style={styles.contact_section}>
				<div style={styles.passenger_contact_wrapper} className=" bold-text font9">
					<span className="emailinput">{t('PASSENGER_DETAILS.EMAIL_ID')}</span>
					<span className="email-input">{t('PASSENGER_DETAILS.EMAIL_CONFIRMATION')}</span>
					<span className="phone-input">{t('PASSENGER_DETAILS.PHONE_NUMBER')}</span>
				</div>
				<div style={styles.passenger_contact_wrapper} className="font10">
					<span className="email-input">
						<KuposInput
							className="kupos-border"
							type="email"
							value={passengerDetails ? passengerDetails.email : ''}
							onChange={text => onChange(text, 'email')}
							onBlur={text => onInputBlur(text, 'email')}
							error={passengerDetails && passengerDetails.emailError ? true : false}
							errorMessage={
								passengerDetails && passengerDetails.emailError
									? t(passengerDetails.emailError)
									: ''
							}
							t={t}
							disabled={loginData ? true : false}

						/>
					</span>
					<span className="email-input">
						<KuposInput
							className="kupos-border confirm-email"
							type="email"
							value={passengerDetails ? passengerDetails.confirmEmail : ''}
							onChange={text => onChange(text, 'confirmEmail')}
							onBlur={text => onInputBlur(text, 'confirmEmail')}
							error={passengerDetails && passengerDetails.confirmEmailError ? true : false}
							errorMessage={
								passengerDetails && passengerDetails.confirmEmailError
									? t(passengerDetails.confirmEmailError)
									: ''
							}
							t={t}
							disabled={loginData ? true : false}
						/>
					</span>
					<span className="phone-input">
						<KuposInput
							placeholder="9XXXXXXXX"
							className="kupos-border"
							type="tel"
							value={passengerDetails ? passengerDetails.mobile : ''}
							onChange={text => onChange(text, 'mobile')}
							onBlur={text => onInputBlur(text, 'mobile')}
							error={passengerDetails && passengerDetails.mobileError ? true : false}
							errorMessage={
								passengerDetails && passengerDetails.mobileError
									? t(passengerDetails.mobileError)
									: ''
							}
							t={t}
							disabled={loginData ? true : false}
						/>
					</span>
				</div>
			</div>
		</div>
	);
};

const SummarySection = ({ cuponera, t }) => {
	const { cuponeraSeats, selectedCuponera } = cuponera;
	const operator = CommonService.getLocal('op');
	return (

		<div className="relative cuponera-sidebar-wrapper">


			{operator && operator.operator_name === "tacoha" ?
				(
					<div className="cuponera-sidebar-relative tachoha-icon-size ">

						<div className="cuponera-sidebar kupos-card">
							<p className="bold-text">Detalles de la compra</p>
							<div className="cuponera-sidebar-hr" />
							{selectedCuponera && (
								<React.Fragment>
									<span className="font9">{selectedCuponera.operator_name}</span>
									<br />
									<span className="font9">{selectedCuponera.no_of_coupons} Pasajes</span>
									<div className="location-details">
										<div className="city-name font11">
											<img
												className="icon-source"
												src={getIcons('Origin', operator)}
												alt={t('TRANSLATIONS.ICON_SOURCE')}
											/>
											<span className="font9">{selectedCuponera.origin}</span>
										</div>

										<div className="city-name font11">
											<img
												className="icon-source"
												src={getIcons('Destination', operator)}
												alt={t('TRANSLATIONS.ICON_SOURCE')}
											/>
											<span className="font9">{selectedCuponera.destination}</span>
										</div>
									</div>
									<hr />

									<div className="d-flex justify-content-between mt-4">
										<span className="font9 ">{selectedCuponera.no_of_coupons} Pasajes</span>
										<span className="font9 bold-text">
											CLP {CommonService.currency(selectedCuponera.total_coupon_amount || 'NA')}
										</span>
									</div>
									<div className="d-flex justify-content-between mt-4">
										<span className="font9 ">Codigo promocion:</span>
										<span
											className="font9 bold-text"
											style={operator ? { color: operator.color_codes.secondary_color } : '#000'}
										>
											CLP {CommonService.currency(selectedCuponera.total_discount_amount || 'NA')}
										</span>
									</div>
								</React.Fragment>
							)}
						</div>
						{selectedCuponera && (
							<div className="cuponera-sidebar-total-sum-box">
								<span className="font9 bold-text">Total</span>
								<span className="font9 bold-text">
									CLP {CommonService.currency(selectedCuponera.total_net_amount)}
								</span>
							</div>
						)}
					</div>
				) : (<div className="cuponera-sidebar-relative ">

					<div className="cuponera-sidebar kupos-card">
						<p className="bold-text">Detalles de la compra</p>
						<div className="cuponera-sidebar-hr" />
						{selectedCuponera && (
							<React.Fragment>
								<span className="font9">{selectedCuponera.operator_name}</span>
								<br />
								<span className="font9">{selectedCuponera.no_of_coupons} Pasajes</span>
								<div className="location-details">
									<div className="city-name font11">
										<img
											className="icon-source"
											src={getIcons('Origin', operator)}
											alt={t('TRANSLATIONS.ICON_SOURCE')}
										/>
										<span className="font9">{selectedCuponera.origin}</span>
									</div>

									<div className="city-name font11">
										<img
											className="icon-source"
											src={getIcons('Destination', operator)}
											alt={t('TRANSLATIONS.ICON_SOURCE')}
										/>
										<span className="font9">{selectedCuponera.destination}</span>
									</div>
								</div>
								<hr />

								<div className="d-flex justify-content-between mt-4">
									<span className="font9 ">{selectedCuponera.no_of_coupons} Pasajes</span>
									<span className="font9 bold-text">
										CLP {CommonService.currency(selectedCuponera.total_coupon_amount || 'NA')}
									</span>
								</div>
								<div className="d-flex justify-content-between mt-4">
									<span className="font9 ">Codigo promocion:</span>
									<span
										className="font9 bold-text"
										style={{ color: operator && operator.color_codes && operator.color_codes.secondary_color ? operator.color_codes.secondary_color : '#000' }}
									>
										CLP {CommonService.currency(selectedCuponera.total_discount_amount || 'NA')}
									</span>
								</div>
							</React.Fragment>
						)}
					</div>
					{selectedCuponera && (
						<div className="cuponera-sidebar-total-sum-box">
							<span className="font9 bold-text">Total</span>
							<span className="font9 bold-text">
								CLP {CommonService.currency(selectedCuponera.total_net_amount)}
							</span>
						</div>
					)}
				</div>)}
		</div>
	);
};

const styles = {
	passenger_inputs_summary_wrapper: {
		display: 'grid',
		gridTemplateColumns: '3fr 1fr',
		gap: 30,
		position: 'relative',
	},
	passenger_inputs_wrapper: {
		flex: 1,
	},
	summary_outer_box: {
		position: 'relative',
		width: '100%',
		marginBottom: 100,
	},

	summary_outer: {
		width: '100%',
		position: 'sticky',
		top: 160,
	},
	summary: {
		zIndex: 100,
	},

	yellow_line: {
		height: 3,
		backgroundColor: '#ccff5f',
		width: '64px',
		marginTop: 10,
		marginBottom: 20,
	},
	line: {
		height: 1,
		backgroundColor: '#D5D5D5',
		marginTop: 18,
		marginBottom: 18,
	},
	place_details: {
		marginTop: 22,
	},
	place: {
		display: 'flex',
		marginBottom: 6,
		alignItems: 'center',
	},
	place_icon: {
		width: 18,
		height: 'auto',
		marginRight: 10,
	},
	seat_type_details: {
		marginTop: 22,
	},
	section_2: {
		marginTop: 22,
	},
	location_pair: {
		margin: '6px 0',
	},
	operator_details: {
		margin: '12px 0',
	},
	operator: {
		marginBottom: 6,
	},
	location_details: {
		margin: '22px 0',
	},
	seats_details: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		margin: '26px 0',
	},

	coupen_details: {
		display: 'flex',
		justifyContent: 'space-between',
	},

	coupen_details_div1: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'cdnter',
	},
	coupen_details_div2: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'cdnter',
	},

	price_tag_selected: {
		position: 'absolute',
		width: '100%',
		backgroundColor: '#fa5e00',
		borderBottomLeftRadius: 12,
		borderBottomRightRadius: 12,
		marginTop: -20,
		bottom: -36,
		paddingTop: 28,
		paddingBottom: 10,
		display: 'flex',
		justifyContent: 'space-between',
		paddingRight: 20,
		paddingLeft: 20,
		color: 'white',
		zIndex: -1,
	},
	cuponera_label: {
		backgroundColor: '#ccff5f',
		width: 'fit-content',
		padding: '8px 15px',
		borderRadius: 50,
		fontSize: '12px',
	},
	info_title: {
		marginBottom: 20,
	},
	passenger_input_wrapper_labels: {
		display: 'grid',
		gridTemplateColumns: '1fr 2fr 2fr 2fr 2fr',
		gap: 15,
		marginBottom: 6,
	},
	passenger_input_wrapper: {
		display: 'grid',
		gridTemplateColumns: '1fr 2fr 2fr 2fr 2fr',
		gap: 10,
		marginBottom: 6,
	},
	contact_section: {
		marginTop: 22,
	},
	passenger_contact_wrapper: {
		display: 'grid',
		gridTemplateColumns: '2fr 2fr 1.3fr',
		gap: 10,
		marginBottom: 6,
	},
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
		common: state.common,
		cuponera: state.cuponera,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(
			{
				...actions,
				...homeActions,
				// ...commonActions,
				...serviceActions,
				...commonActions,
			},
			dispatch,
		),
	};
}
export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withTranslation('common')(CuponeraPayment));



// WEBPACK FOOTER //
// ./src/features/cuponera/CuponeraPayment.js